<template>
  <v-app>
    <v-app-bar scroll-behavior="hide">
      <v-toolbar-title>{{ $t('appbar.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <LanguageDropdown class="mr-1" />
    </v-app-bar>

    <v-main color="basil">
      <v-tabs v-model="tab" color="basil" :grow="$vuetify.display.smAndDown">
        <v-tab value="viewer">{{ $t('viewer.title') }}</v-tab>
        <v-tab value="setting">{{ $t('settings.title') }}</v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-tabs-window v-model="tab">
        <v-tabs-window-item value="viewer" eager>
          <v-sheet>
            <v-container :class="{ 'ms-0': $vuetify.display.smAndDown }">
              <h5 class="my-0">{{ $t('settings.bagWindowSize') }}</h5>
              <v-row>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="bagSizeX"></v-number-input>
                </v-col>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="bagSizeY"></v-number-input>
                </v-col>
              </v-row>
              <h5 class="my-0">{{ $t('settings.badgeAmount') }}</h5>
              <v-row>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="badgeAmountX"></v-number-input>
                </v-col>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="badgeAmountY"></v-number-input>
                </v-col>
              </v-row>
              <h5 class="my-0">{{ $t('settings.badgeOverlap') }}</h5>
              <v-row>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="badgeOverlapX" :step="0.5" :precision="1"></v-number-input>
                </v-col>
                <v-col cols="6" md="4">
                  <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                    density="compact" v-model="badgeOverlapY" :step="0.5" :precision="1"></v-number-input>
                </v-col>
              </v-row>
              <h5 class="my-0">{{ $t('settings.badgeOverlapInvert') }}</h5>
              <v-row>
                <v-col cols="6" md="4">
                  <v-checkbox :label="$t('settings.badgeOverlapInvertHorizontal')"
                    v-model="badgeOverlapInvertX"></v-checkbox>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox :label="$t('settings.badgeOverlapInvertVertical')"
                    v-model="badgeOverlapInvertY"></v-checkbox>
                </v-col>
              </v-row>
              <canvas id="canvas" :style="{ display: 'block', width: '100%', aspectRatio: '4/3' }"></canvas>
            </v-container>

          </v-sheet>
        </v-tabs-window-item>
        <v-tabs-window-item value="setting" eager>
          <v-sheet>
            <v-container :class="{ 'ms-0': $vuetify.display.smAndDown }">
              <h5 class="my-0">{{ $t('settings.badgeType') }}</h5>
              <v-row>
                <v-col cols="6" md="4">
                  <v-select v-model="selectedBadgeType" density="compact" :items="badgeTypeList">
                    <template v-slot:item="{ props: itemProps, item }">
                      <v-list-item v-bind="itemProps" :subtitle="item.subtitle"></v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <template v-if="selectedBadgeType !== 'round'">
                <h5 class="my-0">{{ $t('settings.badgeSize') }}</h5>
                <v-row>
                  <v-col cols="6" md="4">
                    <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                      density="compact" v-model="badgeSizeX"></v-number-input>
                  </v-col>
                  <v-col cols="6" md="4">
                    <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                      density="compact" v-model="badgeSizeY"></v-number-input>
                  </v-col>
                </v-row>
              </template>
              <template v-if="selectedBadgeType === 'round'">
                <h5 class="my-0">{{ $t('settings.badgeDiameter') }}</h5>
                <v-row>
                  <v-col cols="6" md="4">
                    <v-number-input :reverse="false" controlVariant="split" label="" :hideInput="false" :inset="false"
                      density="compact" v-model="badgeDiameter"></v-number-input>
                  </v-col>
                </v-row>
              </template>
              <h5 class="my-0">{{ $t('settings.badgeImage') }}</h5>
              <v-row>
                <v-col cols="12" md="6">
                  <v-file-input density="compact" @change="onBadgeImageChange" accept="image/*"
                    prepend-icon="mdi-image-area"></v-file-input>
                </v-col>
              </v-row>

              <vue-cropper ref="cropper" :src="badgeImageUrl" alt="Source Image" :key="badgeImageUrl" class="w-100"/>
            </v-container>
          </v-sheet>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-main>
    <v-footer class="d-flex align-center justify-center ga-2 flex-wrap flex-grow-1 py-3" color="basil" app="true">
      <v-btn v-for="link in links" :key="link" :text="link" variant="text" rounded></v-btn>

      <div class="flex-1-0-100 text-center mt-2">
        &copy; {{ new Date().getFullYear() }} — <strong><a href="https://x.com/108_chocolat" target="_blank"
            class="text-decoration-none">@108_chocolat</a></strong>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import LanguageDropdown from './components/LanguageDropdown.vue'
import * as THREE from "three"
import { getCurrentInstance } from 'vue'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'App',
  components: {
    LanguageDropdown,
    VueCropper
  },
  data() {
    return {
      tab: 'viewer',
      bagSizeX: 430,
      bagSizeY: 320,
      badgeAmountX: 9,
      badgeAmountY: 7,
      badgeOverlapX: 10,
      badgeOverlapY: 12,
      badgeOverlapInvertX: false,
      badgeOverlapInvertY: false,
      selectedBadgeType: 'round',
      badgeDiameter: 56,
      badgeSizeX: 55,
      badgeSizeY: 55,
      badgeImageUrl: require('@/assets/test.jpg'),
      badgeImageCroppedUrl: require('@/assets/sample.jpg'),
      drawZIndex: 0,
    }
  },
  computed: {
    badgeTypeList() {
      return [
        { title: this.$t('settings.badgeTypeRound'), value: 'round' },
        { title: this.$t('settings.badgeTypeSquare'), value: 'square' },
        { title: this.$t('settings.badgeTypeCheki'), value: 'cheki', subtitle: "55mm x 86mm" },
        { title: this.$t('settings.badgeTypeCard'), value: 'card', subtitle: "63mm x 88mm" },
      ]
    },
  },
  mounted() {
    // Create renderer
    const canvas = document.querySelector('#canvas')
    const renderer = new THREE.WebGLRenderer({
      canvas: canvas
    });
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    renderer.setPixelRatio(window.devicePixelRatio);
    // Create new camera
    const camera = new THREE.OrthographicCamera(
      -canvas.clientWidth / 2,
      canvas.clientWidth / 2,
      canvas.clientHeight / 2,
      -canvas.clientHeight / 2,
    )
    // Create new scene
    this.instance = getCurrentInstance();
    const { proxy } = this.instance;
    proxy.$scene = new THREE.Scene();
    proxy.$camera = camera;
    camera.position.set(0, 0, canvas.clientHeight / 2);
    // Background color
    proxy.$scene.background = new THREE.Color(0xeeeeee);
    // ウインドウリサイズ対応
    const resizeHandler = () => {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      renderer.setSize(width, height, false);
      camera.left = -width / 2;
      camera.right = width / 2;
      camera.top = height / 2;
      camera.bottom = -height / 2;
      camera.position.set(0, 0, height / 2);
      this.updateZoom();
    };
    proxy.$resizeHandler = resizeHandler;
    window.addEventListener('resize', resizeHandler);
    // Rendering
    const animate = () => {
      renderer.render(proxy.$scene, camera);
      // 画面を更新
      // requestAnimationFrame(frame);
    };
    renderer.setAnimationLoop(animate);
    // 初期リサイズ
    this.drawCanvas()
  },
  watch: {
    bagSizeX() {
      // handle bagSizeX change
      this.drawCanvas()
    },
    bagSizeY() {
      // handle bagSizeY change
      this.drawCanvas()
    },
    badgeAmountX() {
      // handle badgeAmountX change
      this.drawCanvas()
    },
    badgeAmountY() {
      // handle badgeAmountY change
      this.drawCanvas()
    },
    badgeOverlapX() {
      // handle badgeOverlapX change
      this.drawCanvas()
    },
    badgeOverlapY() {
      // handle badgeOverlapY change
      this.drawCanvas()
    },
    badgeOverlapInvertX() {
      // handle badgeOverlapInvertX change
      this.drawCanvas()
    },
    badgeOverlapInvertY() {
      // handle badgeOverlapInvertY change
      this.drawCanvas()
    },
    tab() {
      // handle tab change
      if (this.tab === 'viewer') {
        this.applyCrop()
        this.$nextTick(() => {
          this.instance.proxy.$resizeHandler && this.instance.proxy.$resizeHandler()
        })
        this.drawCanvas()
      }
      if (this.tab === 'setting') {
        this.$nextTick(() => {
          this.$refs.cropper && this.$refs.cropper.replace(this.badgeImageUrl)
        })
      }
    },
    selectedBadgeType() {
      // handle selectedBadgeType change
      if (this.selectedBadgeType === 'cheki') {
        this.badgeSizeX = 55;
        this.badgeSizeY = 86;
      } else if (this.selectedBadgeType === 'card') {
        this.badgeSizeX = 63;
        this.badgeSizeY = 88;
      }
    },
  },
  methods: {
    applyCrop() {
      // vue-cropperjsのcropperインスタンスからトリミング画像を取得
      const croppedDataUrl = this.$refs.cropper.getCroppedCanvas().toDataURL('image/png');
      // 画像のリサイズ処理
      let img = new window.Image();
      img.onload = () => {
        let width = img.width;
        let height = img.height;
        const threshold = 512;
        let scale = 1;
        if (width > height && width > threshold) {
          scale = threshold / width;
        } else if (height > width && height > threshold) {
          scale = threshold / height;
        } else if (width === height && width > threshold) {
          scale = threshold / width;
        }
        let resizedDataUrl = croppedDataUrl;
        let canvas = null;
        if (scale < 1) {
          canvas = document.createElement('canvas');
          canvas.width = Math.round(width * scale);
          canvas.height = Math.round(height * scale);
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resizedDataUrl = canvas.toDataURL('image/png');
          // canvasをDOMから削除（念のため）
          if (canvas.parentNode) {
            canvas.parentNode.removeChild(canvas);
          }
          // canvas参照を明示的に破棄
          ctx && ctx.clearRect(0, 0, canvas.width, canvas.height);
          canvas.width = 0;
          canvas.height = 0;
          canvas = null;
        }
        this.badgeImageCroppedUrl = resizedDataUrl;
        this.drawCanvas();
        // Image参照を明示的に破棄
        img.src = '';
        img = null;
        // GCを促す
        if (window.gc) window.gc();
      };
      img.src = croppedDataUrl;
    },
    onBadgeImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (ev) => {
        // 画像サイズが1024px以上の場合、比率を維持して縮小
        const img = new Image();
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          const maxSize = 1024;
          let scale = 1;
          if (width > height && width > maxSize) {
            scale = maxSize / width;
          } else if (height > width && height > maxSize) {
            scale = maxSize / height;
          } else if (width === height && width > maxSize) {
            scale = maxSize / width;
          }
          if (scale < 1) {
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(width * scale);
            canvas.height = Math.round(height * scale);
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            this.badgeImageUrl = canvas.toDataURL('image/png');
          } else {
            this.badgeImageUrl = ev.target.result;
          }
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    },
    updateZoom() {
      const canvas = document.querySelector('#canvas');
      const camera = this.instance.proxy.$camera;
      if (!canvas || !camera) return;
      const margin = 20;
      const zoomX = canvas.clientWidth / (this.bagSizeX + margin * 2);
      const zoomY = canvas.clientHeight / (this.bagSizeY + margin * 2);
      camera.zoom = Math.min(zoomX, zoomY);
      camera.updateProjectionMatrix();
    },
    drawCanvas() {
      this.updateZoom();
      this.drawZIndex = 0;
      const scene = this.instance.proxy.$scene;
      // Clear previous objects
      while (scene.children.length > 0) {
        const child = scene.children[0];
        scene.remove(child);
        child.geometry.dispose();
        child.material.dispose();
      }
      // Add bag rect
      const bagGeometry = new THREE.EdgesGeometry(new THREE.PlaneGeometry(this.bagSizeX, this.bagSizeY));
      const bagMaterial = new THREE.LineBasicMaterial({ color: 0x3a3a3a });
      const bagMesh = new THREE.LineSegments(bagGeometry, bagMaterial);
      bagMesh.position.set(0, 0, 100);
      scene.add(bagMesh);

      const badgeCountX = this.badgeAmountX;
      const badgeCountY = this.badgeAmountY;
      const overlapX = this.badgeOverlapX;
      const overlapY = this.badgeOverlapY;

      if (this.badgeOverlapInvertX) {
        for (let i = badgeCountX - 1; i >= 0; i--) {
          if (this.badgeOverlapInvertY) {
            for (let j = badgeCountY - 1; j >= 0; j--) {
              let x = -this.bagSizeX / 2 + (i + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeX) - i * overlapX;
              let y = -this.bagSizeY / 2 + (j + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeY) - j * overlapY;
              this.addBadge(x, y, this.badgeImageCroppedUrl);
            }
          } else {
            for (let j = 0; j < badgeCountY; j++) {
              let x = -this.bagSizeX / 2 + (i + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeX) - i * overlapX;
              let y = -this.bagSizeY / 2 + (j + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeY) - j * overlapY;
              this.addBadge(x, y, this.badgeImageCroppedUrl);
            }
          }
        }
      } else {
        for (let i = 0; i < badgeCountX; i++) {
          if (this.badgeOverlapInvertY) {
            for (let j = badgeCountY - 1; j >= 0; j--) {
              let x = -this.bagSizeX / 2 + (i + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeX) - i * overlapX;
              let y = -this.bagSizeY / 2 + (j + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeY) - j * overlapY;
              this.addBadge(x, y, this.badgeImageCroppedUrl);
            }
          } else {
            for (let j = 0; j < badgeCountY; j++) {
              let x = -this.bagSizeX / 2 + (i + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeX) - i * overlapX;
              let y = -this.bagSizeY / 2 + (j + 0.5) * (this.selectedBadgeType === 'round' ? this.badgeDiameter : this.badgeSizeY) - j * overlapY;
              this.addBadge(x, y, this.badgeImageCroppedUrl);
            }
          }
        }
      }
    },
    addBadge(x, y, imageUrl) {
      // バッジ画像テクスチャ
      const textureLoader = new THREE.TextureLoader();
      const badgeTexture = textureLoader.load(imageUrl);
      badgeTexture.colorSpace = THREE.SRGBColorSpace;
      const scene = this.instance.proxy.$scene;
      let image, border;
      if (this.selectedBadgeType === 'square' || this.selectedBadgeType === 'card' || this.selectedBadgeType === 'cheki') {
        const geometry = new THREE.PlaneGeometry(this.badgeSizeX, this.badgeSizeY);
        const material = new THREE.MeshBasicMaterial({ map: badgeTexture, transparent: true });
        image = new THREE.Mesh(geometry, material);
        // ボーダーライン
        const borderGeometry = new THREE.EdgesGeometry(geometry);
        const borderMaterial = new THREE.LineBasicMaterial({ color: 0x333333, linewidth: 2 });
        border = new THREE.LineSegments(borderGeometry, borderMaterial);
      } else {
        const geometry = new THREE.CircleGeometry(this.badgeDiameter / 2, 64);
        const material = new THREE.MeshBasicMaterial({ map: badgeTexture, transparent: true });
        image = new THREE.Mesh(geometry, material);
        // 円形ボーダー
        const borderGeometry = new THREE.EdgesGeometry(geometry);
        const borderMaterial = new THREE.LineBasicMaterial({ color: 0x333333, linewidth: 2 });
        border = new THREE.LineSegments(borderGeometry, borderMaterial);
      }
      image.position.set(x, y, this.drawZIndex);
      border.position.set(x, y, this.drawZIndex + 0.5);
      scene.add(image);
      scene.add(border);
      this.drawZIndex += 1; // Increment count for z-index
    }
  },
}
</script>

<style>
.cropper-container {
  background-repeat: repeat !important;
}
</style>
